import { Check } from "lucide-react";

export const STAGES = ["Consultation", "Design", "Manufacturing", "Installation", "Handover"];

export const Milestones = ({ stage = "Consultation", compact = false }) => {
  const currentIdx = Math.max(0, STAGES.indexOf(stage));
  const pct = (currentIdx / (STAGES.length - 1)) * 100;

  return (
    <div className="w-full" data-testid="milestones">
      <div className="relative">
        <div className="absolute left-0 right-0 top-3 h-[2px] bg-black/10" />
        <div
          className="absolute left-0 top-3 h-[2px] bg-[#1C1A17] transition-[width] duration-700 ease-out"
          style={{ width: `${pct}%` }}
        />
        <div className="relative flex justify-between">
          {STAGES.map((s, i) => {
            const done = i < currentIdx;
            const active = i === currentIdx;
            return (
              <div key={s} className="flex flex-col items-center" data-testid={`milestone-${s.toLowerCase()}`}>
                <span
                  className={`h-6 w-6 rounded-full border-2 flex items-center justify-center transition-colors duration-500 ${
                    done
                      ? "bg-[#1C1A17] border-[#1C1A17] text-white"
                      : active
                      ? "bg-white border-[#1C1A17] text-[#1C1A17] ring-4 ring-[#1C1A17]/15"
                      : "bg-white border-black/15 text-transparent"
                  }`}
                >
                  {done ? <Check className="h-3 w-3" /> : active ? <span className="h-2 w-2 rounded-full bg-[#1C1A17]" /> : null}
                </span>
                {!compact && (
                  <span className={`mt-2 text-[10px] tracking-wide uppercase font-semibold ${active ? "text-[#1C1A17]" : done ? "text-[#0A0A0A]" : "text-[#9CA3AF]"}`}>
                    {s}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {compact && (
        <div className="mt-2 text-xs text-[#5C574F]">
          <span className="font-semibold text-[#1C1A17]">{stage}</span>
          <span className="text-[#9CA3AF]"> · Step {currentIdx + 1} of {STAGES.length}</span>
        </div>
      )}
    </div>
  );
};
